export default __webpack_public_path__ + "assets/icons/shipping-method.8ea00a7f.svg";